
export default {
  emits: ['submit'],
  data() {
    return {
      id: undefined,
      name: '',
      name_valid: false,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return this.name_valid
    }
  },
  methods: {
    open({id, name}){
      this.id = id
      this.name = name
      this.loading = false
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        id: this.id,
        name: this.name,
      })
    }
  }
}
